import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPdfFile = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 34 36"
    {...props}
  >
    <path
      fill="#fff"
      stroke="#CBCCD7"
      d="m19.68 3.042.003.039.01.038 1.457 5.964c.076.816.158 1.486.293 2.026.14.553.345 1.014.698 1.373.353.36.807.57 1.35.713.534.139 1.195.223 1.998.3l5.85.998.017.003.018.002c.516.05 1.045.471 1.47 1.183.414.697.656 1.56.656 2.267V31.5c0 2.206-1.764 4-3.875 4h-19.25c-2.113 0-3.875-1.79-3.875-4v-27c0-2.212 1.759-4 3.876-4H16.5c.658 0 1.439.304 2.077.807.641.505 1.052 1.141 1.102 1.735Z"
    />
    <path
      fill="#fff"
      stroke="#CBCCD7"
      d="M19.712 2.874a4.1 4.1 0 0 0-.351-1.356 21 21 0 0 1 1.565 1.034c1.795 1.295 3.802 3.074 5.681 4.998s3.619 3.978 4.884 5.816c.391.57.735 1.114 1.023 1.625a3.9 3.9 0 0 0-1.18-.34h-.007l-.128-.013h-.004l-6.532-.584c-1.588-.142-2.582-.523-3.224-1.18-.644-.66-1.018-1.684-1.157-3.314l-.55-6.454z"
    />
    <rect width={30} height={15} y={17} fill="#F43F3F" rx={3} />
    <path
      fill="#fff"
      d="M9.124 20.789q.693 0 1.221.286.528.285.814.814.297.517.297 1.199 0 .67-.297 1.188t-.847.803q-.54.275-1.254.275h-1.76q-.055 0-.055.055v2.959q0 .055-.044.099a.12.12 0 0 1-.088.033H6.099A.16.16 0 0 1 6 28.467a.16.16 0 0 1-.033-.099v-7.447q0-.055.033-.088a.14.14 0 0 1 .099-.044zm-.187 3.531q.561 0 .902-.33t.341-.869q0-.55-.341-.891-.34-.34-.902-.341H7.298q-.055 0-.055.055v2.321q0 .055.055.055zm3.77 4.18a.16.16 0 0 1-.099-.033.16.16 0 0 1-.033-.099v-7.436q0-.055.033-.088a.14.14 0 0 1 .099-.044h2.684q.78 0 1.375.275.594.274.913.792.33.506.33 1.188v3.19q0 .682-.33 1.199a2.1 2.1 0 0 1-.913.781q-.594.275-1.375.275zm1.144-1.155q0 .055.055.055h1.54q.583 0 .924-.363.352-.375.363-.99v-2.783q0-.627-.352-.99-.352-.375-.946-.374h-1.529q-.055 0-.055.055zm10.727-5.577q0 .055-.044.099a.12.12 0 0 1-.088.033h-3.74q-.055 0-.055.055v2.057q0 .055.055.055h2.519q.055 0 .088.044.045.033.044.088v.836q0 .055-.044.099a.12.12 0 0 1-.088.033h-2.52q-.054 0-.054.055v3.146q0 .055-.044.099a.12.12 0 0 1-.088.033h-1.012a.16.16 0 0 1-.1-.033.16.16 0 0 1-.032-.099v-7.436q0-.055.033-.088a.14.14 0 0 1 .099-.044h4.939q.055 0 .088.044.045.033.044.088z"
    />
  </svg>
);
export default SvgPdfFile;
